<template>
  <div class="scorePicture" style="width: 600px; height: 300px">
    <div ref="main" style="width: 600px; height: 300px"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "ExperimentPlatformScorepicture",
  props: {
    title: {
      require: true,
    },
    detail: {
      require: true,
    },
  },
  data() {
    return {};
  },

  mounted() {
    this.initData();
  },

  methods: {
    initData() {
      let chartDom = this.$refs.main;
      let myChart = echarts.init(chartDom);
      let option;
      let fail = {}; //不及格
      let good = {}; //良好
      let excellent = {}; //优秀
      this.detail.forEach((item) => {
        if (item.level == 1) {
          fail = item;
        }
        if (item.level == 2) {
          good = item;
        }
        if (item.level == 3) {
          excellent = item;
        }
      });
      option = {
        title: {
          text: this.getName(this.title),
          left: "center",
        },
        tooltip: {
          // trigger: "item",
          formatter: (params) => {
            let tooltip =
              params.data.name +
              "：" +
              params.data.value +
              "<br>" +
              "比例：" +
              params.data.rate.toFixed(2)+'%';
            return tooltip;
          },
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            data: [
              { value: fail.count, name: "不及格", rate: fail.rate },
              { value: good.count, name: "良好", rate: good.rate },
              { value: excellent.count, name: "优秀", rate: excellent.rate },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    getName(name) {
      if (name == "elective") {
        return "选修学生";
      }
      if (name == "nonStudents") {
        return "非本校学生";
      }
      if (name == "obligatory") {
        return "必修";
      }
      if (name == "ourStudents") {
        return "本校学生";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.scorePicture {
}
</style>